module.exports = "/_next/static/videos/isra-e528d8f5ca2a90799daae2c34842b507.mp4";